import React, { useState, createContext, useContext, useRef } from "react";

const searchContext = createContext();

export function useSearch() {
  return useContext(searchContext);
}

function useSearchProvider() {
  const drugContainerRef = useRef();

  const [drugCodes, setDrugCodes] = useState([]);
  const [drugDescription, setDrugDescription] = useState("");

  return {
    drugContainerRef,
    drugCodes,
    setDrugCodes,
    drugDescription,
    setDrugDescription,
  };
}

export function SearchProvider({ children }) {
  const search = useSearchProvider();
  return (
    <searchContext.Provider value={search}>{children}</searchContext.Provider>
  );
}
